import { render, staticRenderFns } from "./CtaSpeakers.vue?vue&type=template&id=0d4b31e7&"
import script from "./CtaSpeakers.vue?vue&type=script&lang=js&"
export * from "./CtaSpeakers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports